import { Component, OnInit, Input, SimpleChanges, OnChanges } from '@angular/core';

@Component({
    selector: 'app-liabilities-en-v2',
    templateUrl: './liabilities-en-v2.component.html',
    styleUrls: ['./liabilities-en-v2.component.css'],
    standalone: false
})
export class LiabilitiesEnV2Component implements OnInit, OnChanges {
  @Input() printActive: boolean
  @Input() returnData: any
  @Input() isSinglePageReturn: boolean
  bankFi = [];
  unsecured = [];
  otherLoan = [];

  constructor() { }

  ngOnInit(): void {
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.bankFi = [];
    this.unsecured = [];
    this.otherLoan = [];

    this.returnData?.headSummery?.assetsAndLiabilities?.forEach(item=>{
      if(item.firstSubTypeKey === 'borrowing_from_bank_or_other_fi'){
        this.bankFi = this.bankFi.concat(item.detailsOfAL)
      }
      if(item.firstSubTypeKey === 'unsecured_loan'){
        this.unsecured = this.unsecured.concat(item.detailsOfAL)
      }
      if(item.firstSubTypeKey === 'other_loan_or_overdraft'){
        this.otherLoan = this.otherLoan.concat(item.detailsOfAL)
      }
    })
  }

}
